"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGNORE_EXPIRED_CAUTHNSTATE_FLAG = void 0;
var CommonFunctions_1 = require("../components/common/CommonFunctions/CommonFunctions");
var LoginApi_1 = require("../api/LoginApi");
var LoginConfiguration_1 = require("./LoginConfiguration");
exports.IGNORE_EXPIRED_CAUTHNSTATE_FLAG = 'ingCxp';
var HalocAuthenticationService = /** @class */ (function () {
    function HalocAuthenticationService() {
        this.returnUrl = '';
        this.finalUrl = '';
        // featureToggleDetails: FeatureToggleDetails;
        this.loginApi = new LoginApi_1.default();
        this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
    }
    HalocAuthenticationService.prototype.checkHalocAuthServices = function (flowType, returnUrl, haloClientId) {
        if (haloClientId === void 0) { haloClientId = null; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (haloClientId === null) {
                            haloClientId = this.commonFunctions.isTestEnv() ?
                                LoginConfiguration_1.default.haloCServicesMechIdTest : LoginConfiguration_1.default.haloCServicesMechIdProd;
                        }
                        console.log('HalocAuthenticationService checkHalocAuthServices');
                        sessionStorage.setItem('servicesReturnUrl', returnUrl);
                        sessionStorage.removeItem('halocIsPassiveRedirection');
                        sessionStorage.removeItem('halocLoginRedirectionDone');
                        sessionStorage.removeItem('appshell.halo.redirect.flag.halocIsPassiveRedirection');
                        sessionStorage.removeItem('appshell.halo.redirect.flag.halocLoginRedirectionDone');
                        return [4 /*yield*/, this.checkHalocAuth(flowType, haloClientId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // This is the app-shell entry point
    // adding haloClientId as optional parameter to use a different app id
    // if not passed used IDP clientId
    HalocAuthenticationService.prototype.checkHalocAuth = function (flowType, haloClientId) {
        var _this = this;
        if (haloClientId === void 0) { haloClientId = null; }
        var clientId = haloClientId !== null ? haloClientId : this.commonFunctions.getHalocAppIdForEnv();
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var browserCookie;
            return __generator(this, function (_a) {
                browserCookie = document.cookie;
                this.isHaloSessionAuthenticated(browserCookie, clientId, resolve);
                return [2 /*return*/];
            });
        }); });
    };
    // tslint:disable-next-line:no-any
    HalocAuthenticationService.prototype.isHaloSessionAuthenticated = function (browserCookie, clientId, resolve) {
        var _this = this;
        console.log('isHaloSessionAuthenticated start ...');
        var servicesClientId = this.commonFunctions.isTestEnv() ?
            LoginConfiguration_1.default.haloCServicesMechIdTest :
            LoginConfiguration_1.default.haloCServicesMechIdProd;
        if (browserCookie.includes('TATS-SS-TokenID') && sessionStorage.getItem('servicesReturnUrl') !== null) {
            var servicesReturnUrl = sessionStorage.getItem('servicesReturnUrl');
            console.log('isHaloSessionAuthenticated servicesReturnUrl ...' + servicesReturnUrl);
            if (servicesReturnUrl) {
                console.log('redirecting to - ' + servicesReturnUrl);
                sessionStorage.removeItem('servicesReturnUrl');
                window.location.href = servicesReturnUrl;
            }
            else {
                console.log('isHaloSessionAuthenticated returning resolve..');
                resolve(true);
            }
            // Services flow - set cookie AFTER HALO
            // This will be rolled into sales code in the future
        }
        else if (clientId === servicesClientId && browserCookie.includes('cAuthNState')) {
            var lt = this.commonFunctions.getQueryParam('lt');
            if (this.checkHaloVisitedFlag('halocIsPassiveRedirection', clientId) ||
                this.checkHaloVisitedFlag('halocLoginRedirectionDone', clientId)) {
                // A visited flag set, we're all set.
                resolve(true);
                return;
            }
            else if (lt != null) {
                console.log('login-ui :: isHaloSessionAuthenticated lt is set');
                var vltProm = this.loginApi.validateLoginToken(lt);
                vltProm.then(function (result) {
                    if (result && result.content && result.content.success) {
                        _this.setHaloVisitedFlag('halocIsPassiveRedirection', clientId);
                        // Clear the looping counter.
                        sessionStorage.removeItem('halo.hit.count');
                        resolve(true);
                    }
                    else {
                        console.error('login-ui :: isHaloSessionAuthentiated returned ', result);
                        _this.gotoHalo(clientId);
                    }
                }).catch(function (except) {
                    console.error('exception validating token', except);
                    _this.gotoHalo(clientId);
                });
            }
            else {
                var cookieValue_1 = this.getAuthCookie('cAuthNState', browserCookie);
                // tslint:disable-next-line:no-any
                var parts_1 = cookieValue_1.split(':');
                var now = new Date().getTime(); // Get epoch - halo uses epoch in ms
                if (parts_1.length > 1 && parts_1[1] && now < parts_1[1]) {
                    this.gotoHalo(clientId);
                }
                else {
                    // cAuthNState shows expired, need to check for existing session
                    this.loginApi.inFocus().then(function (res) {
                        if (res &&
                            res.content &&
                            res.content.customerState === 'Authenticated' &&
                            res.content.loggedInId === parts_1[0]) {
                            console.info('login-ui :: expired cauthnstate, but inFocus has session, setting flag');
                            sessionStorage.setItem(exports.IGNORE_EXPIRED_CAUTHNSTATE_FLAG, cookieValue_1);
                            // Go to HALO to ensure 2FA is triggered if necessary
                            _this.gotoHalo(clientId);
                            return;
                        }
                        else {
                            sessionStorage.removeItem(exports.IGNORE_EXPIRED_CAUTHNSTATE_FLAG);
                        }
                        // Release to app shell.
                        resolve(true);
                    }).catch(function (res) {
                        // Log error and release app shell.
                        console.error('login-ui :: error calling inFocus', res);
                        resolve(true);
                    });
                }
            }
            // This block was left untouched 1/11
        }
        else if (browserCookie.includes('cAuthNState')
            && !this.checkHaloVisitedFlag('halocIsPassiveRedirection', clientId)
            && !this.checkHaloVisitedFlag('halocLoginRedirectionDone', clientId)) {
            var cookieValue = this.getAuthCookie('cAuthNState', browserCookie);
            // tslint:disable-next-line:no-any
            var parts = cookieValue.split(':');
            var now = new Date().getTime(); // Get epoch - halo uses epoch in ms
            if (parts.length > 1 && parts[1] && now < parts[1]) {
                console.log('login-ui :: isHaloSessionAuthenticated servicesReturnUrl= ' + sessionStorage.getItem('servicesReturnUrl'));
                this.setHaloVisitedFlag('halocIsPassiveRedirection', clientId);
                sessionStorage.setItem('halo.reg.forgot.actionType', window.location.href);
                var finalURL = this.commonFunctions.createHalocUrl('true', clientId);
                // This removeItme must be after the createHalocUrl, it uses the
                // 'servicesReturnUrl' parameter
                sessionStorage.removeItem('servicesReturnUrl');
                window.location.href = finalURL;
            }
            else {
                resolve(true);
            }
            return;
        }
        else {
            resolve(true);
            return;
        }
    };
    HalocAuthenticationService.prototype.gotoHalo = function (clientId) {
        console.log('login-ui :: gotoHalo servicesReturnUrl= ' + sessionStorage.getItem('servicesReturnUrl'));
        sessionStorage.setItem('halo.reg.forgot.actionType', window.location.href);
        var finalURL = this.commonFunctions.createHalocUrl('true', clientId);
        // This removeItme must be after the createHalocUrl, it uses the
        // 'servicesReturnUrl' parameter
        sessionStorage.removeItem('servicesReturnUrl');
        // Looping check and counter
        var haloCount = parseInt(sessionStorage.getItem('halo.hit.count'), 10);
        if (isNaN(haloCount)) {
            haloCount = 0;
        }
        // one try, one retry then go to error page
        if (haloCount >= 2) {
            sessionStorage.removeItem('halo.hit.count');
            window.location.href = 'https://www.att.com/acctmgmt/login?postAuthError=true';
            return;
        }
        sessionStorage.setItem('halo.hit.count', '' + (haloCount + 1));
        window.location.href = finalURL;
    };
    HalocAuthenticationService.prototype.getAuthCookie = function (cname, browserCookies) {
        if (browserCookies === void 0) { browserCookies = null; }
        var name = cname + '=';
        var decodedCookie = browserCookies == null ? document.cookie : browserCookies;
        var ca = decodedCookie.split(';');
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return decodeURIComponent(c.substring(name.length, c.length));
            }
        }
        return '';
    };
    HalocAuthenticationService.prototype.setHaloVisitedFlag = function (flagName, clientId) {
        // When this flag will expire
        var cAuthNState = this.getValidCAuthNState();
        var expireEpoch = new Date().getTime() +
            (cAuthNState === '' ?
                HalocAuthenticationService.unauthFlagExpire :
                HalocAuthenticationService.idTokenFlagExpire);
        var flag = {
            expire: expireEpoch,
            clientId: clientId,
            cAuthNState: cAuthNState,
        };
        sessionStorage.setItem("appshell.halo.redirect.flag." + flagName, JSON.stringify(flag));
    };
    // Returns true if we've visited HALO
    HalocAuthenticationService.prototype.checkHaloVisitedFlag = function (flagName, clientId) {
        if (clientId === void 0) { clientId = null; }
        var clientIdForFlag = clientId !== null ? clientId : this.commonFunctions.getHalocAppIdForEnv();
        var value = sessionStorage.getItem("appshell.halo.redirect.flag." + flagName);
        if (!value) {
            return false;
        }
        try {
            var flag = JSON.parse(value);
            var cAuthNState = this.getValidCAuthNState();
            if (clientIdForFlag !== flag.clientId ||
                +flag.expire < new Date().getTime()) {
                return false;
            }
            // If there is no auth state cookie, we ignore any flags
            if (cAuthNState === '') {
                return false;
            }
            if (flag.cAuthNState && flag.cAuthNState !== cAuthNState) {
                return false;
            }
            return true;
        }
        catch (e) {
            console.error("exception parsing flag for " + flagName, e);
            return false;
        }
    };
    // Retrieve the cAuthNState cookie and return it if it is valid
    // Valid mean set, and not expired
    HalocAuthenticationService.prototype.getValidCAuthNState = function () {
        var cAuthNState = this.getAuthCookie('cAuthNState');
        if (cAuthNState) {
            var parts = cAuthNState.split(':');
            var now = new Date().getTime(); // Get epoch - halo uses epoch in ms
            if (parts.length > 1 && parts[1] && now < +parts[1]) {
                return cAuthNState;
            }
        }
        return '';
    };
    HalocAuthenticationService.idTokenFlagExpire = 12 * 60 * 1000; // 12 minutes in ms
    HalocAuthenticationService.unauthFlagExpire = 5 * 60 * 1000; // 5 minutes in ms
    return HalocAuthenticationService;
}());
exports.default = HalocAuthenticationService;
//# sourceMappingURL=HalocAuthenticationService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/HalocAuthenticationService.js
// module id = 242
// module chunks = 8